import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Providers } from './app/providers'
import HomePage from './pages/Index'
import AboutPage from './pages/About'
import BusinessesPage from './pages/Businesses'
import AgencyPartnersPage from './pages/AgencyPartners'
import BlogPage from './pages/Blog'
import ContactPage from './pages/Contact'
import CallPage from './pages/Call'
import CareersPage from './pages/Careers'
import JobDetailPage from './pages/JobDetail'
import NotFoundPage from './pages/NotFound'

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Providers>
        <Routes>
          <Route path="/" element={<BusinessesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/businesses" element={<BusinessesPage />} />
          <Route path="/agency-partners" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/call" element={<CallPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/:slug" element={<JobDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Providers>
    </BrowserRouter>
  )
}

export default App

